<form class="itinerary-model-content-inner" [formGroup]="templateDetailsForm">
  <div class="itinerary-model-content">
    <div class="box-title-container mb-1">
      <div class="">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <ion-icon name="create"></ion-icon>
          </div>
          <div>
            <p class="title">Customize Template</p>
          </div>
        </div>
      </div>
    </div>
  
    <div class="form-container ion-padding-horizontal">
      <div class="row">
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Cover Page</label>
            <div>
              <input type="file" accept=".png, .jpg, .jpeg" class="input" (change)="onFileSelected($event, 'image1')">
            </div>
            <div class="img-container">
              <img [src]="getImgUrl(templateDetailsForm.get('image1')?.value)" alt="">
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Emergency Phone Number 1*</label>
            <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber1')?.invalid && templateDetailsForm.get('enquiryNumber1')?.touched }">
              <app-phone-country-input formControlName="enquiryNumber1"></app-phone-country-input>
            </div>
          </div>  
        </div>
      
        <div class="col-4">
          <div class="input-container">
            <label for="" class="label">Emergency Phone Number 2*</label>
            <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber2')?.invalid && templateDetailsForm.get('enquiryNumber2')?.touched }">
              <app-phone-country-input formControlName="enquiryNumber2"></app-phone-country-input>
            </div>
          </div>  
        </div>


      </div>
      
      <div class="row">
        
      </div>
      
      <div class="row">
        
      </div>
      
    </div>
  </div>
  
  <!-- <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-end">
    <ion-button class="unfilled-blue-btn" type="button" (click)="goPrevious()">
      Previous
    </ion-button>
    <div class="d-flex justify-content-end">
      <ion-button type="button" class="filled-blue-btn" (click)="goNext()">
        <ion-text>Next</ion-text>
      </ion-button>
    </div>
    
  </div> -->

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()" data-toggle="tooltip" data-placement="top" title="Tooltip on top">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</form>
